// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { MenuTokens } from './type';

const menuTokens: MenuTokens = {
  menuCollapseWidth: 'Spacing-40',
  menuFontSize: 'Font-14',
  menuFontColor: 'Neutral-text-5',
  menuIconColor: 'Neutral-text-4',
  menuIconMarginX: 'Spacing-8',
  menuPopoverPaddingY: 'Spacing-4',
  menuItemBackgroundColor: 'Neutral-fill-1',
  menuItemFontColor: 'Neutral-text-5',
  menuItemFontWeight: 'Weight-regular',
  menuItemHoverBackgroundColor: 'Neutral-fill-2',
  menuItemHoverFontColor: 'Neutral-text-5',
  menuItemActiveBackgroundColor: 'Brand-1',
  menuItemActiveHoverBackgroundColor: 'Brand-2',
  menuItemActiveFontColor: 'Brand-6',
  menuItemActiveDisabledFontColor: 'Brand-3',
  menuItemDisabledBackgroundColor: 'Neutral-fill-1',
  menuItemDisabledFontColor: 'Neutral-text-2',
  menuItemCollapseActiveBackgroundColor: 'Brand-6',
  menuItemCollapseActiveFontColor: 'Neutral-text-1',
  menuItemInpathActiveFontColor: 'Brand-6',
  menuTitlePaddingX: 'Spacing-16',
  menuTitlePaddingY: 'Spacing-9',
  menuExpandWidth: 'Spacing-46',
  menuExpandSize: 'Font-14',
  menuExpandHoverBackgroundColor: 'Neutral-fill-3',
  menuChildrenBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  menuHeaderBorderColor: 'Neutral-border-1',
  menuHeaderPaddingX: 'Spacing-12',
  menuHeaderPaddingY: 'Spacing-12',
  menuDarkFontColor: 'Neutral-text-1',
  menuDarkItemBackgroundColor: 'Neutral-fill-9',
  menuDarkItemFontColor: 'Neutral-text-1',
  menuDarkItemHoverBackgroundColor: 'Brand-9',
  menuDarkItemHoverFontColor: 'Neutral-text-1',
  menuDarkItemActiveBackgroundColor: 'Brand-6',
  menuDarkItemActiveFontColor: 'Neutral-text-1',
  menuDarkItemOpenBackgroundColor: 'Neutral-fill-10',
  menuDarkItemOpenFontColor: 'Neutral-text-1',
  menuDarkItemDisabledBackgroundColor: 'Neutral-fill-9',
  menuDarkItemDisabledFontColor: 'Neutral-text-4',
  menuDarkItemCollapseActiveBackgroundColor: 'Brand-6',
  menuDarkItemCollapseActiveFontColor: 'Neutral-text-1',
  menuDarkHeaderBorderColor: 'Neutral-fill-8',
  menuSearchBorderRadius: 'Radius-full',
  menuSearchBorderColor: 'Neutral-border-2',
  menuSearchCollapseSize: 'Size-16',
  menuSearchIconSize: 'Size-7',
  menuSearchIconColor: 'Neutral-text-4',
  menuSearchIconMarginX: 'Spacing-8',
  menuSearchBackgroundColor: 'Neutral-fill-2',
  menuSearchClearColor: 'Neutral-text-2',
  menuSearchHoverClearColor: 'Neutral-text-4',
  menuSearchHoverBorderColor: 'Brand-5',
  menuSearchHoverBackgroundColor: 'Neutral-fill-1',
  menuSearchDisabledBackgroundColor: 'Neutral-fill-3',
  menuSearchDarkFontColor: 'Neutral-text-1',
  menuSearchDarkBorderColor: 'Neutral-fill-8',
  menuSearchDarkBackgroundColor: 'Neutral-fill-8',
  menuSearchDarkIconColor: 'Neutral-text-1',
  menuSearchDarkClearColor: 'Neutral-text-3',
  menuSearchDarkPlaceholderFontColor: 'Neutral-text-2',
  menuSearchDarkHoverBorderColor: 'Brand-5',
  menuSearchDarkHoverBackgroundColor: 'Neutral-fill-9',
  menuSearchDarkHoverClearColor: 'Neutral-text-2',
  menuSearchDarkFocusBorderColor: 'Brand-5',
  menuSearchDarkFocusBackgroundColor: 'Neutral-fill-9',
  menuSearchDarkFocusShadow: 'Brand-9',
};

export default menuTokens;
